import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/home";
import List from "./pages/list";
import Edit from "./pages/edit";
import { RouteConfig } from "./route";
import Detail from "./pages/detail";
import SystemConfig from "./pages/system";
import ModulePage from "./pages/module";
import TaskList from "./pages/task/list";
import Login from "./pages/login";
import UserList from "./pages/user";
import VideoMultiAudio from "./pages/video";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem("admin_token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

const MenuInfo = [
  {
    path: RouteConfig.login.path,
    element: <Login />,
  },
  {
    path: RouteConfig.home.path,
    element: <ProtectedRoute><Home /></ProtectedRoute>,
  },
  {
    path: "/scene",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: RouteConfig.sceneList.path,
        element: <List />,
      },
      {
        path: RouteConfig.sceneDetail.path,
        element: <Detail />,
      },
    ],
  },
  {
    path: "/system",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: "config",
        element: <SystemConfig />,
      },
    ],
  },
  {
    path: "/module",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: RouteConfig.modulePage.path,
        element: <ModulePage />,
      },
    ],
  },
  {
    path: "/task",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: RouteConfig.taskPage.path,
        element: <TaskList />,
      },
    ],
  },
  {
    path: "/user",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: RouteConfig.userManagement.path,
        element: <UserList />,
      },
    ],
  },
  {
    path: "/video",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: RouteConfig.videoMultiAudio.path,
        element: <VideoMultiAudio />,
      },
    ],
  },
];

const router = createBrowserRouter(MenuInfo);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
